// extracted by mini-css-extract-plugin
export var hidden = "_sw-0";